import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddMfa = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 92,
	viewBox: "0 0 50 92",
	width: 50,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "m43.8268 0h-37.65467c-3.39497 0-6.17213 2.77715-6.17213 6.17213v78.92257c0 3.395 2.77716 6.1721 6.17213 6.1721h37.65467c3.395 0 6.1732-2.7771 6.1732-6.1721v-78.92257c-.001-3.39498-2.7782-6.17213-6.1732-6.17213zm-18.8273 85.9593c-2.1226 0-3.8528-1.7312-3.8528-3.8528s1.7312-3.8527 3.8528-3.8527 3.8527 1.7311 3.8527 3.8527-1.7301 3.8528-3.8527 3.8528zm21.2334-11.6439h-42.46682v-66.2796h42.46682z",
		fill: "#000",
		fillRule: "evenodd"
	})
});
export { SvgAddMfa as ReactComponent };
